import Service from '../../services';
import { get } from 'lodash';

export const getOfficeInfo = async params => {
  const response = await Service.isnGet(`/api/ouroffice/list-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getOverviewInfo = async params => {
  const response = await Service.isnGet(`/api/ouroffice/overview-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getOfficeTypes = async params => {
  const response = await Service.isnGet(`/api/ouroffice/get-office-types${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getVirtualOfficeTable = async params => {
  const response = await Service.isnGet(`/api/ouroffice/virtual-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getTypeRoomsTable = async params => {
  const response = await Service.isnGet(`/api/ouroffice/type-rooms-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getLocationInfo = async params => {
  const response = await Service.isnGet(`/api/ouroffice/location-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getGalleryInfo = async params => {
  const response = await Service.isnGet(`/api/ouroffice/gallery-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getVideoInfo = async params => {
  const response = await Service.isnGet(`/api/ouroffice/video-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getBenefits = async params => {
  const response = await Service.isnGet(`/api/ouroffice/benefits-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getBanner = async params => {
  const response = await Service.isnGet(`/api/ouroffice/banner-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getIntroduceOffice = async params => {
  const response = await Service.isnGet(`/api/ouroffice/introduces-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getContactsOffice = async params => {
  const response = await Service.isnGet(`/api/ouroffice/contacts-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getServicesOffice = async params => {
  const response = await Service.isnGet(`/api/ouroffice/services-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getQuestionsOffice = async params => {
  const response = await Service.isnGet(`/api/ouroffice/questions-office${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
};

export const getTypesDropdown = async params => {
  const response = await Service.isnGet(`/api/ouroffice/get-types-dropdown${params}`, res => res);
  const data = get(response, 'data', null);
  return data;
}

export const postContactUsRequest = async params => {
  const response = await Service.isnPostFormData(`/api/ouroffice/submit-contact`, params, res => res);
  const data = get(response, 'data', null);
  return data;
};